import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import * as THREE from '@phdsoft/three';

export class MeshUtils {

  public static manifoldVerification(mesh: THREE.Mesh): boolean {

      let geometry = mesh.geometry as THREE.BufferGeometry;
      const v = geometry.attributes.position.count;
      const f = geometry.index.count / 3;
      console.log('before ', geometry.attributes.position.count);
      geometry = mergeVertices(geometry);
      console.log('after ', geometry.attributes.position.count);

      const e = this.countEdges(geometry.index.array as Uint32Array);

      const result = v + f - e;
      console.log(result)
      return v + f - e === 1;
  }

  public static countEdges(index: Uint32Array): number {
    const edgesDictionary = this.mapEdges(index)
      // return Object.values(edgesDictionary).reduce((a, b) => (a as number) + (b as number)) as number;
    return Object.values(edgesDictionary).length;
  }

  private static mapEdges(index: Uint32Array) {
    const edgesDictionary = {}
    for (let i = 0; i < index.length; i += 3) {
        const a = index[i];
        const b = index[i + 1];
        const c = index[i + 2];

        this.checkEdgesInclude(a, b, edgesDictionary);
        this.checkEdgesInclude(b, c, edgesDictionary);
        this.checkEdgesInclude(a, c, edgesDictionary);
    }
    return edgesDictionary
  }

  private static FindSuspiciousPointsPoints(pointList : string[]) : string[] {
    var suspiciousPoints = [];
    var copy = pointList.slice(0);

    for (var i = 0; i < pointList.length; i++) {
      var myCount = 0;
      let index : number = 0
      while (index != -1) {
        index = copy.indexOf(pointList[i])
        if (index != -1) {
          myCount++
          delete copy[index]
        }
      }
      if (myCount > 2) {
        suspiciousPoints.push(pointList[i])
      }
    }
    return suspiciousPoints;
  }

  public static GuaranteeEdgesAreOk(edges : THREE.EdgesGeometry) {
    var cleanPoints : string[] = this.ClearEdgesClonedPoints(edges)
    var fakeBorder = []

    var suspiciousPoints = this.FindSuspiciousPointsPoints(cleanPoints)
    if (suspiciousPoints.length == 0) {
      return edges
    }
    else {
      for (let sus in suspiciousPoints) {
        for (let p = 0; p < cleanPoints.length; p++) {
          if (cleanPoints[p] != undefined) {
            if (cleanPoints[p] == suspiciousPoints[sus]) {
              if (p % 2 == 0 && suspiciousPoints.indexOf(cleanPoints[ p + 1 ]) != -1) {
                fakeBorder.push([`${cleanPoints[p]} ${cleanPoints[p+1]}`, p, p+1])
              }
              if (p % 2 == 1 && suspiciousPoints.indexOf(cleanPoints[ p - 1 ]) != -1) {
                fakeBorder.push([`${cleanPoints[p]} ${cleanPoints[p+1]}`, p-1, p])
              }
            }
          }
        }
      }
      if (fakeBorder.length == 0){
        return edges
      } else {
        for (let f in fakeBorder){
          delete cleanPoints[fakeBorder[f][1]]
          delete cleanPoints[fakeBorder[f][2]]
        }
      }
      var v = this.ConvertPointIndexesToPointCoordenations(cleanPoints, edges)
      var vectors = []
      for(let myVector in v) {
        vectors.push(v[myVector])
      }

      var newEdges = new THREE.BufferGeometry().setFromPoints(vectors);

      return newEdges
    }
  }

  private static ClearEdgesClonedPoints(geometry : THREE.BufferGeometry) {
    const pointsAndYoursCoordenations = this.MapPointsToVector3(geometry)
    let distanceIsZero : [string, number][] = []
    let indexArray : string[] = []

    for (let point in pointsAndYoursCoordenations) {
      indexArray.push(point)
      var p = pointsAndYoursCoordenations[point]
      for (let i = parseInt(point) + 1; i < pointsAndYoursCoordenations.length; i++) {
        let v = pointsAndYoursCoordenations[i]
        var d = p.distanceTo( v );
        if(d == 0) {
          distanceIsZero.push([point, i])
        }
      }
    }
    for ( let i in distanceIsZero) {
      let myIndex = indexArray.indexOf(distanceIsZero[i][1].toString())
      if (myIndex != -1) {
        indexArray[myIndex.toString()] = distanceIsZero[i][0]
      }
    }
    return indexArray
  }

  private static ConvertPointIndexesToPointCoordenations(borderPoints : string[], geometry : THREE.BufferGeometry): any {
    const points = this.MapPointsToVector3(geometry)

    let borderPointsWithCoordenations = [];
    for (let index in borderPoints) {
      var p = borderPoints[index]
      borderPointsWithCoordenations[index] = points[p]
    }
    return borderPointsWithCoordenations
  }

  private static MapPointsToVector3(geometry) : THREE.Vector3[] {
    var positionAttribute = geometry.attributes.position;
    var pointsCoordenations : THREE.Vector3[] = [];
    for (let i = 0; i < positionAttribute.count; i++) {
      var v = new THREE.Vector3()
      v.fromBufferAttribute(positionAttribute, i)
      pointsCoordenations.push(v)
    }
    return pointsCoordenations
  }

  private static checkEdgesInclude(a: number, b: number, edgesDictionary: any): void {
      if (a < b) {
          if (!(a + ' ' + b in edgesDictionary)) edgesDictionary[a + ' ' + b] = 0;
          edgesDictionary[a + ' ' + b]++;
      }
      else {
          if (!(b + ' ' + a in edgesDictionary)) edgesDictionary[b + ' ' + a] = 0;
          edgesDictionary[b + ' ' + a]++;
      }
  }

  public static isFullyVisible(obj: THREE.Object3D): boolean {
    let o: THREE.Object3D | null = obj;
    while (o) {
      if (!o.visible) return false;
      o = o.parent;
    }
    return true;
  }

  /**
   * Flattens object hierarchies into the visible meshes they contain.
   * The patched Raycaster (three-patched.ts) only recurses into visible nodes
   * typed Mesh/Group/Sprite, so recursive raycasts against groups silently miss
   * meshes under other wrappers — raycast against this flattened list instead
   * (same pattern as DTSelectionService.identifyIntersection).
   * InstancedMesh is excluded: it needs per-instance resolution by selection.
   */
  public static collectVisibleMeshes(objects: THREE.Object3D[]): THREE.Mesh[] {
    const meshes: THREE.Mesh[] = [];
    for (const object of objects ?? []) {
      object?.traverse((obj) => {
        if (obj instanceof THREE.InstancedMesh) return;
        if (
          obj instanceof THREE.Mesh &&
          MeshUtils.isFullyVisible(obj) &&
          ((obj.material as THREE.Material)?.visible ?? true)
        ) {
          meshes.push(obj);
        }
      });
    }
    return meshes;
  }
}
